/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainEntitiesClientError } from './FxIdDomainEntitiesClientError';
import {
    instanceOfFxIdDomainEntitiesClientError,
    FxIdDomainEntitiesClientErrorFromJSON,
    FxIdDomainEntitiesClientErrorFromJSONTyped,
    FxIdDomainEntitiesClientErrorToJSON,
} from './FxIdDomainEntitiesClientError';

/**
 * @type FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerRefreshTwitchAccountTokenHandlerResponseError
 * 
 * @export
 */
export type FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerRefreshTwitchAccountTokenHandlerResponseError = FxIdDomainEntitiesClientError;

export function FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerRefreshTwitchAccountTokenHandlerResponseErrorFromJSON(json: any): FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerRefreshTwitchAccountTokenHandlerResponseError {
    return FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerRefreshTwitchAccountTokenHandlerResponseErrorFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerRefreshTwitchAccountTokenHandlerResponseErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerRefreshTwitchAccountTokenHandlerResponseError {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainEntitiesClientError(json)) {
        return FxIdDomainEntitiesClientErrorFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerRefreshTwitchAccountTokenHandlerResponseErrorToJSON(json: any): any {
    return FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerRefreshTwitchAccountTokenHandlerResponseErrorToJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerRefreshTwitchAccountTokenHandlerResponseErrorToJSONTyped(value?: FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerRefreshTwitchAccountTokenHandlerResponseError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainEntitiesClientError(value)) {
        return FxIdDomainEntitiesClientErrorToJSON(value as FxIdDomainEntitiesClientError);
    }

    return {};
}

